<template>
  <v-menu
    key="authorRating"
    @click.native.stop.prevent
    style="display: inline-block;"
    :disabled="disabled"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :small="!showText"
        text
        @click.stop
        v-on="on"
        :class="{
          'ml-0': true,
          'mr-1': true,
          'pa-0': true,
          'no-events': disabled,
          'author-rating-btn': true
        }"
      >
        <v-layout column>
          <answer-icon :questionAnswer="authorAnswer" :questionId="question.id"></answer-icon>
          <answer-text v-if="showText" :questionAnswer="authorAnswer"></answer-text>
        </v-layout>
      </v-btn>
    </template>
    <author-answer-card v-model="authorAnswer"> </author-answer-card>
  </v-menu>
</template>

<script>
import AnswerIcon from './AnswerIcon';
import AuthorAnswerCard from './AuthorAnswerCard';
import AnswerText from './AnswerText';

import { mapActions } from 'vuex';
export default {
  props: {
    question: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  components: { AnswerIcon, AuthorAnswerCard, AnswerText },
  computed: {
    authorAnswer: {
      get() {
        return this.question.authorAnswer;
      },
      set({
        pageId = this.question.id,
        answer = this.authorAnswer.answer,
        confidence = this.authorAnswer.confidence
      }) {
        this.updatePageEvaluation({ pageId, answer, confidence })
      }
    }
  },
  methods: {
    // ...mapActions('context', ['updateQuestionAuthorAnswer'])
    ...mapActions('pages', ['updatePageEvaluation'])
  }
};
</script>

<style>
.no-events {
  pointer-events: none;
}
</style>
